var map = {
	"./Bitcoin": [
		206,
		0
	],
	"./Bitcoin.js": [
		206,
		0
	],
	"./Ethereum": [
		207,
		1
	],
	"./Ethereum.js": [
		207,
		1
	],
	"./Litecoin": [
		208,
		2
	],
	"./Litecoin.js": [
		208,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 404;
module.exports = webpackAsyncContext;